import { render, staticRenderFns } from "./OrderSetKit.vue?vue&type=template&id=6089231a&"
import script from "./OrderSetKit.vue?vue&type=script&lang=js&"
export * from "./OrderSetKit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports